import minimatch from "minimatch";
import { DEPLOY_BLACKLIST } from "../constants";
export default class BlacklistSet extends Set {
    mPatterns;
    constructor(blacklist, game, normalize) {
        super(blacklist.filter((x) => !!x).map((iter) => normalize(iter)));
        const patterns = DEPLOY_BLACKLIST.concat(game.details?.ignoreDeploy ?? []);
        this.mPatterns = patterns.filter((x) => !!x).map((iter) => normalize(iter));
    }
    has(value) {
        if (!value) {
            return false;
        }
        try {
            return (super.has(value) ||
                this.mPatterns.some((pat) => minimatch(value, pat, { nocase: true })));
        }
        catch {
            return false;
        }
    }
}
